import React, { useState } from 'react';
import BarGraph from '../../../../Common/BarGraph/BarGraph';
import GraphHOC from '../../../../Common/GraphHOC/GraphHOC';
import RatingDonutChart from '../../../../Common/RatingDonutChart/DonutChart';
import DonutChart from '../../../../Common/SentimentCharts/SentimentCharts';
import FunnelGraph from '../../../../Common/FunnelGraph/FunnelGraph';
import TitleWithInfo from '../../../../Common/TitleWithInfo/TitleWithInfo';
import CorrelationGraph from '../../../../components/CorrelationGraph/CorrelationGraph';
import WordCloudAnalysis from './WordCloudAnalysis';
import {
    emoji_neutral,
    emoji_surprise,
    emoji_joy,
    emoji_fear,
    emoji_sadness,
    emoji_anger,
    emoji_disgust,
} from '../../../../Common/SvgIcon/CommonSvgIcons';
import VerticalBarGraph from '../../../../Common/BarGraph/VarticalBargraph';
import SmallSelect from '../../../../Common/Select/SmallSelect';
import {
    Wrapper,
    EmotionAnalysisWrapper, FilteredGraphContainer, Footer, FunnelGraphContaining, GraphContainer
} from '../ReportDownload/Insights.styled'
import { useParsedEndDate, useParsedStartDate } from '../../../../utils/ParseDate';
import MapChart from '../../../../components/Maps/WorldMap';


const Insight = ({
    insights_data = {},
    filteredData,
    filterOption,
    filteredStartDate,
    filteredEndDate,
    view,
    resetFlag,
    startDate = '',
    endDate = '',
    formatValue,
    child,
    hideDropdown,
    channel
}) => {

    const formattedDate = useParsedStartDate(false, '', startDate, formatValue);
    const endDateParsed = useParsedEndDate(false, '', endDate, formatValue);

    const COLOR_RANGE_1 = [
        '#C4C4CD',
        '#87D3F2',
        '#4EBEEB',
        '#35B8E8',
        '#188CE6',
        '#1777CF',
        '#155CB4',
      ];
    const [selectedGraph, setSelectedGraph] = useState('Bar Graph');
    if (Object.keys(insights_data).length === 0) {
        return (
            <h2
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '30px',
                }}
            >
                {/* No data available */}Insufficient Data
            </h2>
        );
    }


    const options = ['Bar Graph', 'Pie Chart', 'Donut Chart', 'Funnel Chart'];

    const emotionAnalysis = [
        {
            name: 'Neutral',
            value: resetFlag === true && filteredData
                ? filteredData?.emotion_analysis[0].neutral
                : insights_data?.emotion_analysis[0].neutral,
            // fill: '#F5CC61',
                fill: '#FDE3A2'
    //   fill:'rgba(251, 214, 121,  0.8)'
        },
        {
            name: 'Surprise',
            value: resetFlag === true && filteredData
                ? filteredData?.emotion_analysis[0].surprise
                : insights_data?.emotion_analysis[0].surprise,
            // fill: '#B7DC68',
                fill: '#4FD786'
    //   fill:'rgba(3, 198, 82,  0.8)'
        },
        {
            name: 'Joy',
            value: resetFlag === true && filteredData
                ? filteredData?.emotion_analysis[0].joy
                : insights_data?.emotion_analysis[0].joy,
            // fill: '#FE00D5',
    //   fill:'rgba(218, 6, 184,  0.8)'
                fill: '#E651CE'
        },
        {
            name: 'Fear',
            value: resetFlag === true && filteredData
                ? filteredData?.emotion_analysis[0].fear
                : insights_data?.emotion_analysis[0].fear,
            // fill: '#FC9E58',
    //   fill:'rgba(255, 153, 0,  0.8)'
                fill: '#FFB84D'
        },
        {
            name: 'Sadness',
            value: resetFlag === true && filteredData
                ? filteredData?.emotion_analysis[0].sadness
                : insights_data?.emotion_analysis[0].sadness,
            // fill: '#4B9AE9',
    //   fill:'rgba(21, 112, 203,  0.8)'
                fill: '#5C9BDB'
        },
        {
            name: 'Anger',
            value: resetFlag === true && filteredData
                ? filteredData?.emotion_analysis[0].anger
                : insights_data?.emotion_analysis[0].anger,
            // fill: '#F74945',
    //   fill:'rgba(238, 19, 7,  0.8)'
                fill: '#F14239'
        },
        {
            name: 'Disgust',
            value: resetFlag === true && filteredData
                ? filteredData?.emotion_analysis[0].disgust
                : insights_data?.emotion_analysis[0].disgust,
            // fill: '#9071CE',
    //   fill:'rgba(84, 30, 192,  0.8)'
                fill: '#8862D3'
        },
    ];

    const handleGraphSelect = (selectedOption) => {
        // Your logic to handle the selected graph in the parent component
        setSelectedGraph(selectedOption);
    };

    const renderScreen = {
        'Bar Graph':
            view === 'vertical' ? (
                <VerticalBarGraph data={emotionAnalysis} maxWidth={'70%'} type={'%'} />
            ) : (
                <BarGraph
                    data={emotionAnalysis}
                    maxWidth={'90%'}
                    type={'%'}
                    barHeight={'32px'}
                    emojiList={{
                        neutral: emoji_neutral,
                        surprise: emoji_surprise,
                        joy: emoji_joy,
                        fear: emoji_fear,
                        sadness: emoji_sadness,
                        anger: emoji_anger,
                        disgust: emoji_disgust,
                        length: 2,
                    }}
                />
            ),
        'Pie Chart': (
            <RatingDonutChart data={emotionAnalysis} width={500} type='percentage' is_download={true} />
        ),
        'Donut Chart': <DonutChart data={emotionAnalysis} type='percentage' is_download={true} />,
        'Funnel Chart': (
            <FunnelGraph data={emotionAnalysis} maxWidth={'80%'} type={'%'} />
        ),
    };

    const emotionAnalysisGraph = renderScreen[filterOption];
    const ratingColors = ['rgba(45, 137, 85, 1)', 'rgba(45, 137, 85, 0.8)', 'rgba(45, 137, 85, 0.6)', 'rgba(45, 137, 85, 0.4)', 'rgba(45, 137, 85,0.2)'];

    function convertObjectToBarGraphData(object = {}) {
        const barGraphData = Object.entries(object).map(([name, value]) => ({
            name,
            value: value || 0,
        }));
        const sortData = barGraphData.sort((a, b) => b.value - a.value);
        const dataWithColors = sortData.map((item, index) => ({
            ...item,
            fill: ratingColors[index],
        }));
        return dataWithColors;
        // const barGraphData = Object.entries(object).map(([name, value]) => ({
        //     name,
        //     value: value,
        //     fill: '#353cf7',
        // }));

        // return barGraphData;
    }
    function checkAndConvert(obj) {
        // Check if there's only one key and that key is an empty string, with a value of 0
        if (
            obj &&
            typeof obj === 'object' &&
            Object.keys(obj)?.length === 1 &&
            (obj?.hasOwnProperty('') || obj?.hasOwnProperty(' ')) &&
            (obj[''] === 0 || obj[' '] === 0)
        ) {
            return []; // Return an empty array
        }
        return convertObjectToBarGraphData(obj); // Otherwise, return the original object
    }

    const mostAuthoritativeData =
        checkAndConvert(
            insights_data?.most_authoritative
        ) || [];

    const mostMentionedFunc = () => {

        // Determine which object to use based on resetFlag
        let obj = filteredData ? filteredData?.most_mentioned : insights_data?.most_mentioned;
        const taggedObj = obj && typeof obj === 'object'
        ? Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [`@${key}`, value])
          )
        : {};

        // Call checkAndConvert function with the modified object
        return checkAndConvert(taggedObj) || [];

    }

    const mostMentionedData = mostMentionedFunc() || [];
    // const mostMentionedData =
    //     convertObjectToBarGraphData(
    //         resetFlag === true && filteredData
    //             ? filteredData?.most_authoritative
    //             : insights_data?.most_mentioned
    //     ) || [];

    const renderMostAuthoritative = {
        'Donut Chart': <DonutChart data={mostAuthoritativeData} />,
        'Bar Graph':
            (
                <BarGraph
                    data={mostAuthoritativeData}
                    maxWidth={'70%'}
                    barHeight={'32px'}
                />
            ),

        'Pie Chart': <RatingDonutChart data={mostAuthoritativeData} width={500} is_download={true} />,
        'Donut Chart': <DonutChart data={mostAuthoritativeData} is_download={true} />,
        'Funnel Chart': <FunnelGraph data={mostAuthoritativeData} maxWidth={'80%'} />,


    };

    const renderMostmentioned = {
        'Bar Graph':
            view === 'vertical' ? (
                <VerticalBarGraph
                    data={mostMentionedData}
                    maxWidth={'70%'}
                    barHeight={'32px'}
                />
            ) : (
                <BarGraph
                    data={mostMentionedData}
                    maxWidth={'70%'}
                    barHeight={'32px'}
                />
            ),
        'Pie Chart': <RatingDonutChart data={mostMentionedData} width={500} is_download={true} />,
        'Donut Chart': <DonutChart data={mostMentionedData} is_download={true} />,
        'Funnel Chart': <FunnelGraph data={mostMentionedData} maxWidth={'80%'} />,
    };


    const mostMentionedGraph = renderMostmentioned[filterOption];

    
    return (

        <Wrapper
            className="pdf-page"
            style={{
                pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid',
            }}>
            {
                child?.length > 0 && child[0]?.value &&
                <div
                    className="pdf-page"
                    style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                    }}>
                    <div
                        className="pdf-page"
                        style={{
                            pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                        }}
                    >
                        <WordCloudAnalysis
                            checkboxData={child?.length > 0 && child[0]?.child}
                            selectedButton={child?.length > 0 && child[0]?.value && 'sentiments'}
                            child={child}
                            showSwitchTab={true}
                            insightsData={resetFlag === true && filteredData ? filteredData : insights_data}
                            hideDropdown={hideDropdown}
                            startDate={formattedDate}
                            endDate={endDateParsed}
                        />
                    </div>
                </div>

            }
            {
                child?.length > 0 && child[1]?.value &&
                <div className="pdf-page"
                    style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                    }}>
                    <div
                        className="pdf-page"
                        style={{
                            pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', width: '100%', marginTop: '50px'
                        }}
                    >
                        <WordCloudAnalysis
                            checkboxData={child?.length > 0 && child[1]?.child}
                            selectedButton={child?.length > 0 && child[1]?.value && 'emotions'}
                            child={child}
                            showSwitchTab={true}
                            insightsData={resetFlag === true && filteredData ? filteredData : insights_data}
                            hideDropdown={hideDropdown}
                            startDate={formattedDate}
                            endDate={endDateParsed}
                        />
                    </div>
                </div>

            }
            {
                // filterOption ? (
                //     <EmotionAnalysisWrapper className="pdf-page" style={{ 
                //         pageBreakBefore: 'auto',pageBreakAfter:'auto',pageBreakInside:'avoid' }}>
                //         <p>Most  Mentioned</p>
                //         <FilteredGraphContainer>{mostMentionedGraph}</FilteredGraphContainer>
                //     </EmotionAnalysisWrapper>
                // ) : (

                child?.length > 0 && child[2]?.value && child[2]?.display &&
                <div className="pdf-page" style={{
                    pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid'
                }}>
                    <EmotionAnalysisWrapper className="pdf-page" style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid'
                    }}>
                        <GraphHOC
                            title={'Most Authoritative'}
                            options={options}
                            renderScreen={renderMostAuthoritative}
                            graphWidth={'100%'}
                            margin={'20px 0px 20px 50px'}
                            option={
                                child[2]?.child?.find(i => i?.value === true)?.name
                            }
                            // option={child[3]?.child?.find(i => i?.value === true)?.name}
                            hideDropdown={hideDropdown}
                            startDate={formattedDate}
                            endDate={endDateParsed}
                            infoText='ss'
                        />
                    </EmotionAnalysisWrapper>
                </div>
                // )
            }

            {
                // filterOption ? (
                //     <EmotionAnalysisWrapper className="pdf-page" style={{ 
                //         pageBreakBefore: 'auto',pageBreakAfter:'auto',pageBreakInside:'avoid' }}>
                //         <p>Most  Mentioned</p>
                //         <FilteredGraphContainer>{mostMentionedGraph}</FilteredGraphContainer>
                //     </EmotionAnalysisWrapper>
                // ) : (

                child?.length > 0 && child[3]?.value && child[3]?.display &&
                <div className="pdf-page" style={{
                    pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid'
                }}>

                    <EmotionAnalysisWrapper className="pdf-page" style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '20px'
                    }}>
                        <GraphHOC
                            title={'Most Mentioned'}
                            options={options}
                            renderScreen={renderMostmentioned}
                            graphWidth={'100%'}
                            margin={'20px 0px 20px 50px'}
                            // option={child[3]?.value == true}
                            option={child[3]?.child?.find(i => i?.value === true)?.name}
                            hideDropdown={hideDropdown}
                            startDate={formattedDate}
                            endDate={endDateParsed}
                            infoText='ss'
                        />
                    </EmotionAnalysisWrapper>
                </div>
                // )
            }

            {(

                child?.length > 0 && child[4]?.value == true &&
                <div  className="pdf-page" style={{
                    pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid'
                }}>

                    <EmotionAnalysisWrapper className="pdf-page" style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid'
                    }}>
                        <GraphHOC
                            title={'Emotion Analysis'}
                            // options={options[0]}
                            renderScreen={renderScreen}
                            graphWidth={'100%'}
                            margin={'20px 0px 20px 50px'}
                            startDate={formattedDate}
                            endDate={endDateParsed}
                            option={child[4]?.child?.find(i => i?.value === true)?.name}
                            hideDropdown={hideDropdown}
                            infoText='ss'
                        />
                    </EmotionAnalysisWrapper>
                </div>
            )}
            {
                child?.length > 0 && child[5]?.display == true &&  child[5]?.value == true &&
                <div
                    className="pdf-page"
                    style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '30px'
                    }}
                >
                    <CorrelationGraph
                        showSwitchTab={true}
                        RatingLabels={[
                            'Engagement',
                            'Anger',
                            'Neutral',
                            'Sadness',
                            'Disgust',
                            'Fear',
                            'Joy',
                            'Surprise',
                        ]}
                        correlationAnalysisData={
                            filteredData && resetFlag === true
                                ? filteredData?.correlation_analysis
                                : insights_data?.correlation_analysis
                        }
                        hideDropdown={hideDropdown}
                        startDate={formattedDate}
                        endDate={endDateParsed}
                    />
                </div>
            }

            {

                child?.length > 0 && child?.[6]?.value == true &&
                <div
                    className="pdf-page"
                    style={{
                        pageBreakBefore: 'auto', pageBreakAfter: 'auto', pageBreakInside: 'avoid', marginTop: '30px'
                    }}
                >
                      {( insights_data?.map_data?.length > 0) &&
                    <MapChart
                        channel={channel}
                        mapData={
                             insights_data?.map_data
                        }
                        // text={`The majority of the engagers were from ${stateWithHighestReviews}`}
                        colorRange={COLOR_RANGE_1}

                        startDate={formattedDate}
                        endDate={endDateParsed}
                    />}
                </div>
            }
        </Wrapper>
    );
};

export default Insight;
